(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.HeroCarousel) return;

    var prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    function HeroCarousel(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-carousel-viewport]');
      this.track = root.querySelector('[data-carousel-track]');

      this.slides = Array.prototype.slice.call(
        root.querySelectorAll('[data-carousel-slide]')
      );

      this.dots = Array.prototype.slice.call(
        root.querySelectorAll('[data-carousel-dot]')
      );

      this.prevBtn = root.querySelector('[data-carousel-prev]');
      this.nextBtn = root.querySelector('[data-carousel-next]');
      this.index = 0;
      this.timer = null;

      this.autoplay = root.getAttribute('data-autoplay') === 'true' &&
        !prefersReducedMotion;

      this.speed = parseInt(
        root.getAttribute('data-autoplay-speed'),
        10
      ) || 5000;

      if (!this.track || this.slides.length === 0) return;

      this.bindEvents();
      this.goTo(0, true);

      if (this.autoplay && this.slides.length > 1) {
        this.play();
      }
    }

    HeroCarousel.prototype.goTo = function (index, instant) {
      var count = this.slides.length;
      this.index = ((index % count) + count) % count;

      if (instant) {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';

      if (instant) {
        void this.track.offsetHeight;
        this.track.style.transition = '';
      }

      this.slides.forEach(function (slide, i) {
        var active = i === this.index;

        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        var focusable = slide.querySelectorAll('a, button');

        for (var f = 0; f < focusable.length; f++) {
          focusable[f].tabIndex = active ? 0 : -1;
        }
      }, this);

      this.dots.forEach(function (dot, i) {
        var active = i === this.index;

        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    HeroCarousel.prototype.next = function () {
      this.goTo(this.index + 1);
      this.restart();
    };

    HeroCarousel.prototype.prev = function () {
      this.goTo(this.index - 1);
      this.restart();
    };

    HeroCarousel.prototype.play = function () {
      this.stop();

      if (this.slides.length < 2) return;

      var self = this;

      this.timer = window.setInterval(function () {
        self.goTo(self.index + 1);
      }, this.speed);
    };

    HeroCarousel.prototype.stop = function () {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    };

    HeroCarousel.prototype.restart = function () {
      if (this.autoplay) {
        this.play();
      }
    };

    HeroCarousel.prototype.bindEvents = function () {
      var self = this;

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.next();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.prev();
        });
      }

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.goTo(parseInt(dot.getAttribute('data-slide-index'), 10));
          self.restart();
        });
      });

      this.root.addEventListener('mouseenter', function () {
        self.stop();
      });

      this.root.addEventListener('mouseleave', function () {
        self.restart();
      });

      this.root.addEventListener('focusin', function () {
        self.stop();
      });

      this.root.addEventListener('focusout', function () {
        self.restart();
      });

      this.root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.prev();
        if (e.key === 'ArrowRight') self.next();
      });

      if (this.viewport) {
        var startX = 0;
        var startY = 0;
        var dragging = false;

        this.viewport.addEventListener('touchstart', function (e) {
          var t = e.touches[0];

          startX = t.clientX;
          startY = t.clientY;
          dragging = true;
          self.stop();
        }, { passive: true });

        this.viewport.addEventListener('touchmove', function (e) {
          if (!dragging) return;

          var t = e.touches[0];
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;

          if (Math.abs(dx) > Math.abs(dy)) {
            e.preventDefault();
          }
        }, { passive: false });

        this.viewport.addEventListener('touchend', function (e) {
          if (!dragging) return;

          dragging = false;

          var t = e.changedTouches[0];
          var dx = t.clientX - startX;

          if (Math.abs(dx) > 40) {
            if (dx < 0) {
              self.next();
            } else {
              self.prev();
            }
          } else {
            self.restart();
          }
        });
      }

      document.addEventListener('shopify:block:select', function (e) {
        if (!self.root.contains(e.target)) return;

        var slide = e.target.closest('[data-carousel-slide]');

        if (slide) {
          self.stop();
          self.goTo(parseInt(slide.getAttribute('data-slide-index'), 10));
        }
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        if (!self.root.contains(e.target)) return;
        self.restart();
      });

      document.addEventListener('shopify:section:select', function (e) {
        if (e.target === self.root || self.root.contains(e.target)) {
          self.stop();
        }
      });

      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target === self.root || self.root.contains(e.target)) {
          self.restart();
        }
      });
    };

    window.HeroCarousel = HeroCarousel;

    function init(scope) {
      var roots = (scope || document).querySelectorAll(
        '[data-hero-carousel]:not([data-carousel-initialized])'
      );

      roots.forEach(function (root) {
        root.setAttribute('data-carousel-initialized', 'true');
        new HeroCarousel(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cuulu-review-cards')) {
    customElements.define('cuulu-review-cards', class extends HTMLElement {
      connectedCallback() {
        this.sortApplied = false;
        this.observedCards = new Set();
        this.loadedIds = new Set();
        this.signature = '';
        this.pending = false;
        this.failed = false;

        this.onClick = event => {
          if (
            event.target.closest('.jm-filters, .jm-review-widget__header') &&
            !event.target.closest('.crc-feed')
          ) {
            this.pending = false;
            clearTimeout(this.loadTimer);
          }

          if (event.target.closest('.crc-more__button')) this.loadMore();
          if (event.target.closest('.crc-photo-close')) {
            this.querySelector('.crc-photo-dialog').close();
          }

          const thumbnail = event.target.closest('.crc-feed .jm-media-thumbnail-list__thumbnail');
          if (thumbnail) this.openPhoto(thumbnail);
        };

        this.onKey = event => {
          const thumbnail = event.target.closest('.crc-feed .jm-media-thumbnail-list__thumbnail');

          if (thumbnail && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            this.openPhoto(thumbnail);
          }
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);

        this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());

        this.onChange = event => {
          if (event.target.closest('.jm-sort-filter, .jm-filters')) {
            this.pending = false;
            clearTimeout(this.loadTimer);
          }

          if (event.isTrusted && event.target.matches('.jm-sort-filter__select')) {
            this.sortApplied = true;
          }
        };

        this.addEventListener('change', this.onChange);

        this.observer = new MutationObserver(() => {
          this.scheduleSort();
          this.scheduleLayout();
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(() => this.syncReviews(), 120);
        });

        this.observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-current', 'review-uuid']
        });

        this.scheduleSort();
        this.scheduleLayout();
        this.syncTimer = setTimeout(() => this.syncReviews(), 150);
      }

      nextButton() {
        const nav = this.querySelector('.jm-pagination-controls');

        return nav?.querySelector('button[aria-label="Go to next page"]') ||
          [...(nav?.querySelectorAll('.jm-pagination-controls__button--nav') || [])].at(-1);
      }

      nativeCards() {
        const list = this.querySelector('.jdgm-review-list');

        return list
          ? [...list.children].filter(card => card.matches('.jm-review-item'))
          : [];
      }

      cardId(card) {
        return card.getAttribute('review-uuid');
      }

      syncReviews() {
        if (this.failed) return;

        const cards = this.nativeCards();
        const feed = this.querySelector('.crc-feed');
        const more = this.querySelector('.crc-more');

        if (!feed || !more || !cards.length || cards.some(card => !this.cardId(card))) return;

        const next = this.nextButton();
        if (!next && !this.classList.contains('crc-enhanced')) return;

        const signature = cards.map(card => this.cardId(card)).join('|');
        if (signature === this.signature) return;

        const append = this.pending;

        if (!append) {
          feed.replaceChildren();
          this.loadedIds.clear();
        }

        let added = 0;

        cards.forEach(card => {
          const id = this.cardId(card);
          if (this.loadedIds.has(id)) return;

          const copy = card.cloneNode(true);
          copy.style.gridColumn = '';
          copy.style.gridRow = '';

          copy.querySelectorAll('button, input, select, textarea, [role="button"]').forEach(control => {
            if (!control.matches('.jm-media-thumbnail-list__thumbnail')) {
              control.remove();
            }
          });

          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          copy.removeAttribute('id');

          copy.querySelectorAll('.jm-media-thumbnail-list__thumbnail').forEach(photo => {
            photo.setAttribute('role', 'button');
            photo.setAttribute('tabindex', '0');
            photo.setAttribute('aria-label', 'Open customer review photo');
          });

          if (append) {
            copy.classList.add('crc-review-enter');
            copy.style.setProperty('--crc-reveal-delay', `${Math.min(added, 6) * 65}ms`);
          }

          feed.append(copy);
          this.loadedIds.add(id);
          added++;
        });

        this.signature = signature;

        const list = this.querySelector('.jdgm-review-list');

        if (feed.nextElementSibling !== more || more.nextElementSibling !== list) {
          list.before(feed, more);
        }

        feed.hidden = false;
        more.hidden = false;
        this.classList.add('crc-enhanced');
        this.pending = false;

        if (append && this.scrollHold) {
          this.scrollHold.until = performance.now() + 3000;
        }

        clearTimeout(this.loadTimer);
        feed.removeAttribute('aria-busy');

        const button = more.querySelector('button');
        button.disabled = false;
        button.textContent = 'Show more';
        button.hidden = !next || next.disabled || next.getAttribute('aria-disabled') === 'true';

        more.querySelector('[role="status"]').textContent = append
          ? `${added} more reviews loaded. ${this.loadedIds.size} reviews shown.`
          : '';

        this.scheduleLayout();
      }

      loadMore() {
        const next = this.nextButton();

        if (this.pending || !next || next.disabled) return;

        this.pending = true;

        const feed = this.querySelector('.crc-feed');
        feed.setAttribute('aria-busy', 'true');

        const button = this.querySelector('.crc-more__button');
        button.disabled = true;
        button.textContent = 'Loading…';

        this.querySelector('.crc-more__status').textContent = '';
        this.holdScrollPosition();

        const realScrollTo = window.scrollTo;
        const realScrollIntoView = Element.prototype.scrollIntoView;

        window.scrollTo = () => {};
        Element.prototype.scrollIntoView = () => {};

        const restoreScrollMethods = () => {
          window.scrollTo = realScrollTo;
          Element.prototype.scrollIntoView = realScrollIntoView;
        };

        setTimeout(restoreScrollMethods, 1200);
        next.click();

        this.loadTimer = setTimeout(() => {
          if (!this.pending) return;

          this.releaseScrollPosition();
          this.failed = true;
          this.pending = false;
          this.classList.remove('crc-enhanced');
          feed.hidden = true;
          button.hidden = true;

          this.querySelector('.crc-more__status').textContent =
            'Reviews could not be loaded. Please use the page controls below.';

          this.scheduleLayout();
        }, 15000);
      }

      holdScrollPosition(duration = 16000) {
        this.releaseScrollPosition();

        this.scrollHold = {
          x: window.scrollX,
          y: window.scrollY,
          until: performance.now() + duration
        };

        this.cancelScrollHold = () => this.releaseScrollPosition();

        this.cancelScrollKey = event => {
          if (
            ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Tab', 'Escape'].includes(event.key)
          ) {
            this.releaseScrollPosition();
          }
        };

        window.addEventListener('wheel', this.cancelScrollHold, {
          passive: true,
          capture: true
        });

        window.addEventListener('touchstart', this.cancelScrollHold, {
          passive: true,
          capture: true
        });

        window.addEventListener('pointerdown', this.cancelScrollHold, true);
        window.addEventListener('keydown', this.cancelScrollKey, true);

        const hold = () => {
          const anchor = this.scrollHold;
          if (!anchor) return;

          if (performance.now() >= anchor.until || !this.isConnected) {
            this.releaseScrollPosition();
            return;
          }

          if (
            Math.abs(window.scrollY - anchor.y) > 1 ||
            Math.abs(window.scrollX - anchor.x) > 1
          ) {
            window.scrollTo({
              left: anchor.x,
              top: anchor.y,
              behavior: 'instant'
            });
          }

          this.scrollFrame = requestAnimationFrame(hold);
        };

        this.scrollFrame = requestAnimationFrame(hold);
      }

      releaseScrollPosition() {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollHold = null;

        window.removeEventListener('wheel', this.cancelScrollHold, true);
        window.removeEventListener('touchstart', this.cancelScrollHold, true);
        window.removeEventListener('pointerdown', this.cancelScrollHold, true);
        window.removeEventListener('keydown', this.cancelScrollKey, true);
      }

      openPhoto(thumbnail) {
        const image = thumbnail.querySelector('img');
        if (!image) return;

        const url = new URL(image.currentSrc || image.src, document.baseURI);
        if (!['https:', 'http:'].includes(url.protocol)) return;

        url.searchParams.delete('width');

        const dialog = this.querySelector('.crc-photo-dialog');
        dialog.querySelector('img').src = url.href;

        if (!dialog.open) dialog.showModal();
      }

      scheduleLayout() {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.layoutCards());
      }

      layoutCards() {
        const liveCards = new Set();

        this.querySelectorAll(
          this.classList.contains('crc-enhanced') ? '.crc-feed' : '.jdgm-review-list'
        ).forEach(list => {
          const cards = [...list.children].filter(card => card.matches('.jm-review-item'));

          if (!cards.length || !list.getBoundingClientRect().width) return;

          cards.forEach(card => {
            card.style.gridColumn = 'auto';
            card.style.gridRow = 'auto';
          });

          list.classList.add('crc-masonry');

          const style = getComputedStyle(list);
          const columns = style.gridTemplateColumns.split(/\s+/).filter(Boolean).length;
          const gap = parseFloat(style.columnGap) || 20;
          const heights = cards.map(card => card.getBoundingClientRect().height);
          const bottoms = Array(columns).fill(0);

          cards.forEach((card, index) => {
            const column = bottoms.indexOf(Math.min(...bottoms));
            const span = Math.max(1, Math.ceil(heights[index]));

            card.style.gridColumn = String(column + 1);
            card.style.gridRow = `${bottoms[column] + 1} / span ${span}`;

            bottoms[column] += span + gap;
            liveCards.add(card);

            if (!this.observedCards.has(card)) {
              this.resizeObserver.observe(card);
            }
          });
        });

        this.observedCards.forEach(card => {
          if (!liveCards.has(card)) {
            this.resizeObserver.unobserve(card);
          }
        });

        this.observedCards = liveCards;
      }

      scheduleSort() {
        if (this.sortApplied) return;

        clearTimeout(this.sortTimer);

        this.sortTimer = setTimeout(() => {
          const select = this.querySelector('.jm-sort-filter__select');

          if (
            !select ||
            !this.querySelector('.jm-review-item') ||
            !select.querySelector('option[value="pictures_first"]')
          ) {
            return;
          }

          this.sortApplied = true;

          if (select.value !== 'pictures_first') {
            // Judge.me can scroll its widget into view after a programmatic sort.
            // Preserve the landing position while that initial render settles.
            // Real touch, pointer, wheel, or keyboard input releases immediately.
            this.holdScrollPosition(10000);

            select.value = 'pictures_first';
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 600);
      }

      disconnectedCallback() {
        this.releaseScrollPosition();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();

        cancelAnimationFrame(this.layoutFrame);
        clearTimeout(this.sortTimer);
        clearTimeout(this.syncTimer);
        clearTimeout(this.loadTimer);

        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('change', this.onChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-routine-recommendations"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cuulu-product-row')) {

  customElements.define(
    'cuulu-product-row',

    class extends HTMLElement {

      connectedCallback() {

        this.track =
          this.querySelector(
            '[data-cuulu-recs-track]'
          );

        this.previous =
          this.querySelector(
            '[data-cuulu-recs-prev]'
          );

        this.next =
          this.querySelector(
            '[data-cuulu-recs-next]'
          );

        this.status =
          this.querySelector(
            '[data-cuulu-recs-status]'
          );

        if (
          !this.track ||
          !this.previous ||
          !this.next
        ) {
          return;
        }


        this.onScroll = () => {

          window.requestAnimationFrame(
            () => this.updateControls()
          );

        };


        this.onClick = event => {

          const button =
            event.target.closest(
              '[data-cuulu-recs-prev], [data-cuulu-recs-next]'
            );

          if (
            !button ||
            !this.contains(button)
          ) {
            return;
          }


          const cards = [
            ...this.track.querySelectorAll(
              '.cuulu-recs__card'
            )
          ];

          if (!cards.length) {
            return;
          }


          const trackStyle =
            getComputedStyle(
              this.track
            );

          const rtl =
            trackStyle.direction === 'rtl';

          const position =
            Math.abs(
              this.track.scrollLeft
            );

          const gap =
            parseFloat(
              trackStyle.columnGap ||
              trackStyle.gap
            ) || 0;

          const cardWidth =
            cards[0]
              .getBoundingClientRect()
              .width;

          const step =
            cardWidth + gap;

          const direction =
            button === this.previous
              ? -1
              : 1;

          const maximum =
            this.track.scrollWidth -
            this.track.clientWidth;

          const target =
            Math.max(
              0,
              Math.min(
                maximum,
                position +
                direction * step
              )
            );

          this.track.scrollTo({

            left:
              target *
              (rtl ? -1 : 1),

            behavior:
              matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches
                ? 'auto'
                : 'smooth'

          });

        };


        this.addEventListener(
          'click',
          this.onClick
        );

        this.track.addEventListener(
          'scroll',
          this.onScroll,
          {
            passive: true
          }
        );


        this.resizeObserver =
          new ResizeObserver(
            () => {
              this.updateControls();
            }
          );

        this.resizeObserver.observe(
          this.track
        );

        this.updateControls();

      }


      updateControls() {

        if (!this.track) {
          return;
        }

        const maximum =
          this.track.scrollWidth -
          this.track.clientWidth;

        const position =
          Math.abs(
            this.track.scrollLeft
          );

        const overflowing =
          maximum > 2;


        this.previous.hidden =
          !overflowing;

        this.next.hidden =
          !overflowing;


        this.previous.disabled =
          position < 2;

        this.next.disabled =
          position >= maximum - 2;


        if (this.status) {

          const cards = [
            ...this.track.querySelectorAll(
              '.cuulu-recs__card'
            )
          ];

          if (!cards.length) {

            this.status.hidden = true;

            return;

          }


          const trackStyle =
            getComputedStyle(
              this.track
            );

          const gap =
            parseFloat(
              trackStyle.columnGap ||
              trackStyle.gap
            ) || 0;

          const cardWidth =
            cards[0]
              .getBoundingClientRect()
              .width;

          const step =
            cardWidth + gap;

          const first =
            step
              ? Math.round(
                  position / step
                ) + 1
              : 1;

          const mobile =
            matchMedia(
              '(max-width: 749px)'
            ).matches;

          this.status.hidden =
            !overflowing ||
            !mobile;

          this.status.textContent =
            `${Math.min(first, cards.length)} / ${cards.length}`;

        }

      }


      disconnectedCallback() {

        this.removeEventListener(
          'click',
          this.onClick
        );

        this.track?.removeEventListener(
          'scroll',
          this.onScroll
        );

        this.resizeObserver?.disconnect();

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();
})();
